<div class="tabs px-1 py-3 p-sm-3">
  <mat-tab-group (selectedIndexChange)="onSelectTab($event)" class="tabs__group">
    <mat-tab *ngFor="let tab of serviceRequestsTabs | keyvalue: asIsOrder" [label]="tab.value">
      <app-cargo-list-service-requests *ngIf="activeTab === tab.value" [typeList]="tab.key"></app-cargo-list-service-requests>
    </mat-tab>
  </mat-tab-group>
</div>
